//import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  getApps() {
    return new Promise((resolve, reject) => {
      api
        .get("dashboard/apps")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  }
};
